import { ComponentType } from "./ComponentType";

export const INITIAL_VALUES: ComponentType = {
	componentTypeId: 0,
	componentTypeName: "",
	rootTypeId: 0,
	isRepair: true,
	isTracked: true,
};
